/* Team K9 harness-page patch module: snippets/tk9-pp-patch.liquid (rendered by sections/tk9-bb-tests.liquid) sets it
   up. Records: Pages outputs/k9-patch-checkbox-ab-20261019/HANDOFF.md (the 2026-10-19 test, and the shared module of
   2026-10-20 in shared-20261020/).
   State b (2026-10-20): everyone gets B, our module, on the 4 harness product pages; Candy Rack's box is hidden.
     4MBH runs it in kit mode (the "Kit option" copy that won tk9-bb-4mbh-1), the others in box mode.
   States on/preview: the 2026-10-19 50/50 below (A = Candy Rack as is, B = ours).
   ---- the 2026-10-19 test ----
Team K9 harness-page patch checkbox test tk9-pp-patch-1 (2026-10-19). Setup, arm and kill switch:
   snippets/tk9-pp-patch.liquid (rendered by sections/tk9-bb-tests.liquid). Record: Pages
   outputs/k9-patch-checkbox-ab-20261019/HANDOFF.md

   A: Candy Rack's "Customize It?" checkbox exactly as today. Nothing here changes it: at the Add press this only reads
      whether its box was ticked, for the Watch count.
   B: our own checkbox in Candy Rack's place (its block is hidden in B): "Customize It?", a card with the live
      patch-pair preview and the real price (no strikethrough). Ticked = the name is required (15 characters), the
      phone is optional (15). The pair (Medium for Extra-Small and Small harnesses, Large otherwise, as every other
      patch surface; the shopper can switch) is added as its own line right after the harness, quantity 1, with the two
      properties the patch supplier reads ("Which text or name you want printed", "Which phone number you want printed
      (optional)"), the hidden mockup and source fields our other patch surfaces write, and _tk9_pp_patch_arm=b. No
      _tk9_upsell, so the slide cart treats the line as it treats Candy Rack's (a normal line, no second patch row).
      Slide cart on: the line goes in through its TK9CartExtraItems hook. Slide cart off in this browser: the harness and
      the patch are added together, then /cart.
   Both arms: cart attribute _tk9_pp_patch_arm = a | b (+ _tk9_pp_v), and pp:A|B in the buy-box tests' _tk9_bb_arm.
   Watch: component tk9.pp.patch.<arm> on the page's experiment exposure (the page's own experiment, or
   tk9-pp-patch-1 when it has none), tk9.pp.add.<arm> on a product-page add, tk9.pp.patchadd.<arm> when that add carried
   the checkbox patch. */
(function () {
  var PP = window.TK9PP;
  if (!PP || !PP.arm || window.__tk9ppRan) return;
  window.__tk9ppRan = true;
  var C = PP.conf, arm = PP.arm, low = arm.toLowerCase(), h = document.documentElement;
  var NAME = 'Which text or name you want printed', PHONE = 'Which phone number you want printed (optional)';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function emit(name, data) {
    var p = { event: 'tk9_pp_' + name, tk9_pp_arm: arm, tk9_pp_v: PP.v };
    for (var k in data || {}) p[k] = data[k];
    try { (window.dataLayer = window.dataLayer || []).push(p); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('tk9:pp', { detail: p })); } catch (e) {}
  }
  function drawerOn() { return !!(window.TK9Cart && typeof window.TK9Cart.active === 'function' && window.TK9Cart.active()); }
  function getForm() { return $('product-form-component form[action*="/cart/add"]'); }
  function getSticky() { return $('.sticky-add-to-cart__form'); }
  function crBlock() { return $('[id*="candy_rack_product_placement_checkbox"]'); }

  /* ---------------- the arm rides on the cart ---------------- */
  // XHR (the layout's fetch wrapper repaints /cart on cart writes). Read back after other writes settle; written only
  // when missing or different, so the slide cart's and the buy-box tests' attributes are never overwritten.
  var attrTimer = null, attrTries = 0;
  function xhr(method, url, body, done) {
    try {
      var x = new XMLHttpRequest();
      x.open(method, url);
      x.setRequestHeader('Accept', 'application/json');
      if (body) x.setRequestHeader('Content-Type', 'application/json');
      x.onloadend = function () { var j = null; try { j = JSON.parse(x.responseText); } catch (e) {} done(x.status >= 200 && x.status < 300 ? j : null); };
      x.send(body ? JSON.stringify(body) : null);
    } catch (e) { done(null); }
  }
  function ensureAttr(delay) {
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      xhr('GET', '/cart.js', null, function (c) {
        if (!c || !c.item_count) return;
        var at = c.attributes || {};
        if (at._tk9_pp_patch_arm === low && at._tk9_pp_v === PP.v) { attrTries = 0; return; }
        if (++attrTries > 4) return;
        xhr('POST', '/cart/update.js', { attributes: { _tk9_pp_patch_arm: low, _tk9_pp_v: PP.v } }, function (j) {
          emit('attr', { value: low, ok: !!j });
          ensureAttr(1500);
        });
      });
    }, delay);
  }
  if (Number(C.count) > 0 && C.attr !== low) ensureAttr(600);
  document.addEventListener('cart:update', function () { attrTries = 0; ensureAttr(1400); });

  /* ---------------- Watch ---------------- */
  // Watch keeps one experiment a page visit. A page with no experiment declares this one (before the recorder starts at
  // load); on a page that has one (e.g. the classic page's tk9-bb-classic-1) the arm rides as a component of that same
  // exposure, so that test's read is untouched.
  if (!h.getAttribute('data-watch-experiment')) {
    h.setAttribute('data-watch-experiment', PP.exp); h.setAttribute('data-watch-variant', arm); h.setAttribute('data-watch-page-version', PP.exp + ':' + arm);
  }
  var wq = ['tk9.pp.patch.' + arm], wTimer = null, wTries = 0;
  function wflush() {
    clearTimeout(wTimer);
    var rec = window.MerchantingWatch, e = h.getAttribute('data-watch-experiment'), v = h.getAttribute('data-watch-variant');
    if (rec && typeof rec.track === 'function' && e && v) {
      wq = wq.filter(function (c) {
        try { return rec.track('experiment_exposed', { experiment_id: e, variant_id: v, page_version_id: h.getAttribute('data-watch-page-version') || '', component_id: c }) !== true; } catch (x) { return true; }
      });
    }
    if (wq.length && ++wTries < 30) wTimer = setTimeout(wflush, 3000);
  }
  function wpush(c) { if (wq.indexOf(c) < 0) wq.push(c); wTries = 0; wflush(); }
  setTimeout(wflush, 2500);

  // the Add press: was the checkbox patch ticked (A: Candy Rack's box; B: ours)? Read before the slide cart unticks it.
  var lastTick = false;
  function tickedNow() {
    if (arm === 'B') return !!(B && B.on && B.name());
    return $$('.candyrack-ppp-checkbox-layout__offer input[type=checkbox]').some(function (c) { return c.checked; });
  }
  function isOurForm(f) { return f && (f === getForm() || f === getSticky()); }
  document.addEventListener('submit', function (e) { if (isOurForm(e.target) && !e.defaultPrevented) lastTick = tickedNow(); }, true);
  document.addEventListener('tk9:cart', function (e) {
    var d = e.detail || {};
    if (d.event !== 'tk9_cart_add_confirmed') return;
    wpush('tk9.pp.add.' + arm); if (lastTick) wpush('tk9.pp.patchadd.' + arm);
    emit('add', { patch: lastTick, via: d.tk9_source || d.source || '' });
    lastTick = false; attrTries = 0; ensureAttr(700);
    if (B && B.on && B.added) B.afterAdd();
  });
  emit('exposed', { handle: C.handle, forced: PP.forced });

  if (arm !== 'B') return;

  /* ---------------- B: the shared patch module (2026-10-20) ----------------
     Owner: "it would prolly be best to get rid of candyrack and have an optimal way for patches". One module on the 4
     harness product pages, in place of Candy Rack's "Customize It?" box (hidden):
       mode 'box' (classic, lightweight, 10-in-1): "Customize It?" with a patch card, in Candy Rack's place.
       mode 'kit' (4MBH while tk9-bb-4mbh-1 is shipped to B): the buy-box "Kit option" copy that won that test, in its
       spot; tk9-bb-tests.js leaves its own kit out when this mode runs. Same line properties as that kit.
     Both: a live preview of the pair with the typed name and phone, name (required) and phone (optional) with
     15-character counters (the supplier's limit), the patch size picked from the harness size by the slide cart's map
     (Extra-Small and Small = Medium, the rest Large; no dropdown), the real price with no strikethrough, the two supplier
     properties, and _tk9_upsell so the slide cart shows the line as its ticked patch row (the /cart patch card hides
     itself when the cart has the patch). One tick = at most one patch line: the box unticks after the add. */
  var KIT = C.mode === 'kit', P = C.patch, MAXC = 15;
  var css = document.createElement('style');
  css.textContent =
    '.tk9pp{margin:6px 0 16px;color:inherit}' +
    '.tk9pp-h{margin:0;font-weight:700;font-size:22px;line-height:1.25}' +
    '.tk9pp-sub{margin:4px 0 12px;font-size:15.5px;line-height:1.4}' +
    '.tk9pp-opt{display:grid;grid-template-columns:22px 104px minmax(0,1fr);align-items:center;column-gap:12px;width:100%;margin:0;padding:12px;' +
      'border:0;border-radius:12px;background:#fff;color:inherit;font:inherit;text-align:left;cursor:pointer;-webkit-appearance:none;appearance:none;' +
      'box-shadow:inset 0 0 0 1px rgba(0,0,0,.22);-webkit-tap-highlight-color:transparent}' +
    '.tk9pp-opt[aria-pressed="true"]{box-shadow:inset 0 0 0 2px rgb(28,210,172);background:#f4fdfa}' +
    '.tk9pp-tick{width:22px;height:22px;border-radius:6px;box-shadow:inset 0 0 0 2px #5b6170;display:grid;place-items:center;background:#fff}' +
    '.tk9pp-opt[aria-pressed="true"] .tk9pp-tick{box-shadow:none;background:rgb(28,210,172)}' +
    '.tk9pp-opt[aria-pressed="true"] .tk9pp-tick::after{content:"";width:6px;height:11px;margin-top:-2px;border:solid #fff;border-width:0 2.5px 2.5px 0;transform:rotate(45deg)}' +
    '.tk9pp-img{display:block;width:104px;height:auto;aspect-ratio:900/520;border-radius:8px;background:#f7f8fa}' +
    '.tk9pp-opt[aria-pressed="true"]{grid-template-columns:22px minmax(0,1fr)}.tk9pp-opt[aria-pressed="true"] .tk9pp-img{display:none}' +   /* ticked: the big preview below shows it */
    '.tk9pp-copy{display:grid;gap:3px;min-width:0}' +
    '.tk9pp-copy b{font-size:15.5px;line-height:1.3}' +
    '.tk9pp-copy small{font-size:13.5px;line-height:1.35;opacity:.8}' +
    '.tk9pp-copy em,.tk9pp-opt>em{font-style:normal;font-weight:700;font-size:15.5px;line-height:1.3}' +
    /* kit mode: the look of the buy-box kit option that won tk9-bb-4mbh-1 */
    '.tk9pp--kit{margin:0 0 14px}' +
    '.tk9pp--kit .tk9pp-h{display:block;width:100%;margin:0 0 10px;font-size:15px;line-height:1.3;text-align:center}' +
    '.tk9pp--kit .tk9pp-opt{grid-template-columns:22px minmax(0,1fr) auto;align-items:start;column-gap:10px;padding:11px 12px;border-radius:10px;min-height:48px}' +
    '.tk9pp--kit .tk9pp-opt[aria-pressed="true"]{background:#fff}' +
    '.tk9pp--kit .tk9pp-tick{width:20px;height:20px;margin-top:1px;border-radius:5px;box-shadow:inset 0 0 0 2px currentColor;background:transparent}' +
    '.tk9pp--kit .tk9pp-copy{gap:2px}' +
    '.tk9pp--kit .tk9pp-copy b,.tk9pp--kit .tk9pp-opt>em{font-size:15px;line-height:1.25}' +
    '.tk9pp--kit .tk9pp-copy small{opacity:.85;line-height:1.3}' +
    '.tk9pp--kit .tk9pp-opt>em{white-space:nowrap}' +
    /* the shared fields */
    /* ticked (2026-10-20, owner: the big preview pushed Add to Cart down): two compact fields side by side, then one small
       live patch with the size line beside it; the module grows by about 110 px when ticked */
    '.tk9pp-fields{display:grid;grid-template-columns:1fr 1fr;gap:6px 8px;margin-top:8px}' +
    '.tk9pp-fields[hidden]{display:none}' +
    '.tk9pp-fields label{display:grid;gap:3px;min-width:0;font-size:12.5px;font-weight:600;line-height:1.2}' +
    '.tk9pp-lab{display:flex;justify-content:space-between;align-items:baseline;gap:4px;min-width:0;white-space:nowrap}' +
    '.tk9pp-n{flex:none;font-size:11.5px;font-weight:500;opacity:.7;font-variant-numeric:tabular-nums}' +
    '.tk9pp-n.is-full{opacity:1;font-weight:700}' +
    '.tk9pp-fields input{width:100%;min-width:0;height:40px;min-height:0;margin:0;padding:6px 9px;border:1px solid rgba(0,0,0,.32);border-radius:8px;background:#fff;color:inherit;font:inherit;font-size:16px;line-height:1.2}' +
    '.tk9pp-fields input[data-pp-name]{text-transform:uppercase}' +
    '.tk9pp-row2{grid-column:1/-1;display:flex;align-items:center;gap:10px;min-width:0}' +
    '.tk9pp-one{display:block;flex:none;width:150px;height:auto;aspect-ratio:820/230}' +
    '.tk9pp-sz{margin:0;min-width:0;font-size:12.5px;line-height:1.3;opacity:.85}' +
    '.tk9pp-err{grid-column:1/-1;margin:0;color:#b42318;font-size:13px;font-weight:600}' +
    '.tk9pp-err[hidden]{display:none}' +
    '.tk9pp.is-missing input[data-pp-name]{border-color:#b42318;box-shadow:0 0 0 1px #b42318}' +
    '@media(max-width:360px){.tk9pp-opt{grid-template-columns:22px 76px minmax(0,1fr);column-gap:10px}.tk9pp--kit .tk9pp-opt{grid-template-columns:22px minmax(0,1fr) auto}.tk9pp-img{width:76px}.tk9pp-one{width:130px}}';
  document.head.appendChild(css);

  var FIELDS =
    '<div class="tk9pp-fields" data-pp-fields hidden>' +
      '<label><span class="tk9pp-lab">Name to print<span class="tk9pp-n" data-pp-nn aria-hidden="true">0/15</span></span>' +
        '<input type="text" maxlength="15" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="next" data-pp-name></label>' +
      '<label><span class="tk9pp-lab">Phone (optional)<span class="tk9pp-n" data-pp-pn aria-hidden="true">0/15</span></span>' +
        '<input type="text" maxlength="15" autocomplete="off" inputmode="tel" enterkeyhint="done" data-pp-phone></label>' +
      '<div class="tk9pp-row2"><img class="tk9pp-one" data-pp-prev alt="Preview of your patch with the name you type" width="820" height="230"><p class="tk9pp-sz" data-pp-sz></p></div>' +
      '<p class="tk9pp-err" data-pp-err hidden>Type the name to print, or untick the ' + (KIT ? 'patch' : 'patches') + '.</p>' +
    '</div>';
  var box = document.createElement('div');
  box.className = 'tk9pp' + (KIT ? ' tk9pp--kit' : ''); box.setAttribute('data-tk9pp', KIT ? 'kit' : 'box');
  box.setAttribute('data-watch-component', KIT ? 'tk9.bb.4mbh.kit' : 'tk9.pp.patch'); box.setAttribute('data-watch-kind', 'upsell');
  box.innerHTML = KIT
    ? '<p class="tk9pp-h">Kit option</p>' +
      '<button type="button" class="tk9pp-opt" aria-pressed="false" data-pp-toggle data-watch-component="tk9.bb.4mbh.kit.patch" data-watch-kind="upsell">' +
        '<span class="tk9pp-tick" aria-hidden="true"></span>' +
        '<span class="tk9pp-copy"><b data-pp-label>Harness + custom name patch</b><small>Their name and your number, printed on a pair</small></span><em data-pp-price></em>' +
      '</button>' + FIELDS
    : '<p class="tk9pp-h">Customize It?</p>' +
      '<p class="tk9pp-sub">Add a pair of custom name patches to your harness!</p>' +
      '<button type="button" class="tk9pp-opt" aria-pressed="false" data-pp-toggle data-watch-component="tk9.pp.patch.toggle" data-watch-kind="upsell">' +
        '<span class="tk9pp-tick" aria-hidden="true"></span>' +
        '<img class="tk9pp-img" data-pp-img alt="" width="104" height="60">' +
        '<span class="tk9pp-copy"><b>Custom name patches</b><small>A matching pair for both sides, printed with your dog’s name and your phone number, so whoever finds them knows who to call.</small><em data-pp-price></em></span>' +
      '</button>' + FIELDS;
  var tog = $('[data-pp-toggle]', box), fields = $('[data-pp-fields]', box), nameIn = $('[data-pp-name]', box), phoneIn = $('[data-pp-phone]', box);
  var err = $('[data-pp-err]', box), thumb = $('[data-pp-img]', box), prev = $('[data-pp-prev]', box), priceEm = $('[data-pp-price]', box);
  var nn = $('[data-pp-nn]', box), pn = $('[data-pp-pn]', box), szP = $('[data-pp-sz]', box), label = $('[data-pp-label]', box);

  // printable ASCII, single spaces, upper case: what the patch prints (the /cart patch card's rule)
  function clean(v) { return String(v || '').replace(/[^\x20-\x7E]/g, '').replace(/\s{2,}/g, ' ').trim(); }
  function esc(t) { return t.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // the patch-pair preview of the harness product-page patch block (blocks/tk9-pdp-custom-patch.liquid)
  function pairImage(dogName, phone) {
    var line1 = esc(clean(dogName).toUpperCase() || 'CUSTOM PATCH'), line2 = esc(clean(phone).toUpperCase());
    var primarySize = line2 ? (line1.length > 16 ? '48' : line1.length > 12 ? '58' : '70') : (line1.length > 16 ? '58' : line1.length > 12 ? '72' : '88');
    var phoneSize = line2.length > 17 ? '28' : '34';
    var nameFit = line1.length > 8 ? ' textLength="612" lengthAdjust="spacingAndGlyphs"' : '';
    var phoneFit = line2.length > 17 ? ' textLength="560" lengthAdjust="spacingAndGlyphs"' : '';
    function patch(y) {
      var py = y + (line2 ? 84 : 122);
      var ph = line2 ? '<text x="450" y="' + (y + 134) + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + phoneSize + '" font-weight="900" fill="#ffffff"' + phoneFit + '>' + line2 + '</text>' : '';
      return '<g filter="url(#shadow)"><rect x="85" y="' + y + '" width="730" height="190" rx="28" fill="#24272b" stroke="#454a50" stroke-width="10"/><rect x="120" y="' + (y + 32) + '" width="660" height="126" rx="18" fill="url(#patchBg)" stroke="#333a42" stroke-width="5"/><text x="450" y="' + py + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + primarySize + '" font-weight="900" fill="#ffffff"' + nameFit + '>' + line1 + '</text>' + ph + '</g>';
    }
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="900" height="520" viewBox="0 0 900 520"><defs><linearGradient id="patchBg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#282b2f"/><stop offset=".64" stop-color="#101214"/><stop offset="1" stop-color="#25282c"/></linearGradient><filter id="shadow" x="-18%" y="-24%" width="136%" height="160%"><feDropShadow dx="0" dy="12" stdDeviation="14" flood-color="#101828" flood-opacity=".24"/></filter></defs><rect width="900" height="520" rx="30" fill="#f7f8fa"/>' + patch(58) + patch(272) + '</svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }
  // one patch of the pair, same artwork as pairImage, for the small ticked preview
  function onePatch(dogName, phone) {
    var line1 = esc(clean(dogName).toUpperCase() || 'CUSTOM PATCH'), line2 = esc(clean(phone).toUpperCase());
    var primarySize = line2 ? (line1.length > 16 ? '48' : line1.length > 12 ? '58' : '70') : (line1.length > 16 ? '58' : line1.length > 12 ? '72' : '88');
    var phoneSize = line2.length > 17 ? '28' : '34';
    var nameFit = line1.length > 8 ? ' textLength="612" lengthAdjust="spacingAndGlyphs"' : '';
    var phoneFit = line2.length > 17 ? ' textLength="560" lengthAdjust="spacingAndGlyphs"' : '';
    var py = line2 ? 104 : 142;
    var ph = line2 ? '<text x="410" y="154" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + phoneSize + '" font-weight="900" fill="#ffffff"' + phoneFit + '>' + line2 + '</text>' : '';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="820" height="230" viewBox="0 0 820 230"><defs><linearGradient id="pb" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#282b2f"/><stop offset=".64" stop-color="#101214"/><stop offset="1" stop-color="#25282c"/></linearGradient></defs>' +
      '<rect x="45" y="20" width="730" height="190" rx="28" fill="#24272b" stroke="#454a50" stroke-width="10"/><rect x="80" y="52" width="660" height="126" rx="18" fill="url(#pb)" stroke="#333a42" stroke-width="5"/>' +
      '<text x="410" y="' + py + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + primarySize + '" font-weight="900" fill="#ffffff"' + nameFit + '>' + line1 + '</text>' + ph + '</svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function checked(prefix) { var x = $$('input[type="radio"]').filter(function (i) { return i.checked && (i.name || '').indexOf(prefix) === 0; })[0]; return x ? x.value : ''; }
  // the slide cart's map for these harnesses (Extra-Small, Small = Medium; the rest Large); no dropdown
  function sizeForHarness() { return /^(Extra-Small|Small)\b/i.test(checked('Choose a Size')) ? 'm' : 'l'; }
  function pick() { var want = sizeForHarness(), other = want === 'm' ? 'l' : 'm'; return P[want] && P[want].ok ? want : (P[other] && P[other].ok ? other : null); }
  var SIZE_TXT = { m: 'Medium, 4.3 × 1.2 in', l: 'Large, 6.3 × 2.0 in' };

  var B = {
    on: false, used: false, added: false, mode: KIT ? 'kit' : 'box',
    name: function () { return clean(nameIn.value).toUpperCase(); },
    phone: function () { return clean(phoneIn.value); },
    afterAdd: function () { B.added = false; setOn(false, 'added'); },
  };
  window.TK9PP.B = B;

  function count(el, v) { var n = v.length; setText(el, n + '/' + MAXC); el.classList.toggle('is-full', n >= MAXC); }
  function paint() {
    var k = pick();
    box.hidden = !k;
    var price = k ? String(P[k].price).replace(/\s+USD$/, '') : '';   // as the drawer shows it: "$24.99"
    setText(priceEm, KIT && price ? '+' + price : price);
    if (KIT) setText(label, (checked('Choose a Kit') || 'Harness') + ' + custom name patch');
    setText(szP, k ? SIZE_TXT[k] + ', sized to your harness' : '');
    var src = pairImage(nameIn.value, phoneIn.value), one = onePatch(nameIn.value, phoneIn.value);
    if (thumb && thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
    if (!fields.hidden && prev.getAttribute('src') !== one) prev.setAttribute('src', one);
    count(nn, B.name()); count(pn, B.phone());
  }
  function setOn(v, why) {
    B.on = v; B.used = false; tog.setAttribute('aria-pressed', String(v)); fields.hidden = !v; err.hidden = true; box.classList.remove('is-missing');
    crIgnore(); paint();
    if (v && why === 'tap') setTimeout(function () { try { if (!nameIn.value) nameIn.focus({ preventScroll: true }); } catch (e) {} }, 40);
    emit('toggle', { on: v, why: why || '', mode: B.mode });
  }
  tog.addEventListener('click', function () { setOn(!B.on, 'tap'); });
  nameIn.addEventListener('input', function () { if (B.name()) { err.hidden = true; box.classList.remove('is-missing'); } paint(); });
  phoneIn.addEventListener('input', paint);

  // box: Candy Rack's place (its block is hidden), else right before the buy buttons (after Candy Rack is uninstalled).
  // kit: inside the product form before its buttons, where the buy-box kit option sat.
  function mount() {
    var f = getForm();
    if (KIT) {
      if (f && box.parentNode !== f) { var bt = $('.product-form-buttons', f); if (bt) f.insertBefore(box, bt); else f.insertBefore(box, f.firstChild); }
    } else {
      var cr = crBlock();
      if (cr && cr.parentNode && (box.parentNode !== cr.parentNode || box.nextElementSibling !== cr)) cr.parentNode.insertBefore(box, cr);
      else if (!cr && !document.body.contains(box)) { var blk = f && f.closest('.buy-buttons-block'); if (blk && blk.parentNode) blk.parentNode.insertBefore(box, blk); }
    }
    paint();
  }
  function placed() { return document.body.contains(box) && (KIT ? box.parentNode === getForm() : (!crBlock() || box.nextElementSibling === crBlock())); }
  mount();
  if (!document.body.contains(box)) { emit('error', { message: 'no place to mount', mode: B.mode }); return; }
  var moTimer = null, host = (getForm() && (getForm().closest('.product-details') || getForm().closest('product-form-component'))) || document.body;   // holds the box in both modes
  try { new MutationObserver(function () { clearTimeout(moTimer); moTimer = setTimeout(function () { if (!placed()) mount(); else paint(); }, 80); }).observe(host, { childList: true, subtree: true }); } catch (e) {}
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, variant-swatch-king')) { setTimeout(paint, 60); setTimeout(mount, 600); } });
  document.addEventListener('variant:update', function () { setTimeout(mount, 60); setTimeout(mount, 600); });

  function props() {
    var n = B.name(), p = B.phone(), o = {}, surf = KIT ? 'tk9_bb_kit' : 'tk9_pp_checkbox';
    o[NAME] = n; if (p) o[PHONE] = p;
    // the fields the drawer and /cart patch rows write, so the mockup email, production and reporting read it the same
    o._tk9_patch_mockup_format = 'svg_v4_pair_cart_single_preview';
    o._tk9_patch_mockup_line_1 = n; o._tk9_patch_mockup_line_2 = p;
    o._tk9_custom_patch_source = 'product_page'; o._tk9_custom_patch_label = 'Product page';
    o._tk9_custom_patch_surface = surf; o._tk9_custom_patch_source_label = 'Product page'; o._tk9_custom_patch_source_surface = surf;
    if (KIT) o._tk9_upsell = 'bb:patch:kit';                       // as the buy-box kit wrote it (tk9-bb-4mbh-1 read)
    else { o._tk9_pp_patch_arm = 'b'; o._tk9_upsell = 'pp:patch'; }   // tagged: the slide cart shows its ticked patch row
    return o;
  }
  function patchItem() { var k = pick(); return k ? { id: P[k].id, quantity: 1, properties: props() } : null; }

  /* One patch per harness, in its latest size and text (2026-10-28, tickets #112631/#112633). A second Add with the box
     ticked used to put a second identical patch on the same line (quantity 2, charged, shown by the drawer as one row),
     and a size switch left the old-size patch next to the new one. At the Add press the module reads the cart it last
     saw: a patch already there with the same name (any size, any surface) and no more harnesses than such patches means
     no second patch; when its size or phone differs, the new patch replaces one unit of it after the add. Another name
     (a second dog) or a harness that has no patch yet still gets one. */
  var HARN = { 'all-metal-tactical-harness': 1, 'metal-buckle-harness': 1, 'lightweight-dog-harness': 1, 'full-set-sale': 1 };
  /* The cart it reads is fresh or not used: the slide-cart-off path reads /cart.js at the Add press; the slide cart's
     hook is synchronous, so it uses the copy re-read on every cart event, tick, name edit and return to the tab, and
     only while that copy is under 30 s old. A cart changed where this page can't see it (another tab, /cart, a console
     clear) once made it skip a wanted patch (2026-10-28 v2 rollback); without a fresh read the patch is added. */
  var cartNow = null, cartAt = 0, drop = null, inflight = false, readTimer = null;
  function loadCart(done) { xhr('GET', '/cart.js', null, function (c) { var ok = !!(c && c.items); if (ok) { cartNow = c; cartAt = Date.now(); } if (done) done(ok ? c : null); }); }
  function readSoon() { clearTimeout(readTimer); readTimer = setTimeout(loadCart, 300); }
  loadCart();
  document.addEventListener('cart:update', function () { setTimeout(loadCart, 250); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
  window.addEventListener('focus', readSoon);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') readSoon(); });
  tog.addEventListener('click', readSoon);
  nameIn.addEventListener('input', readSoon);
  function plan(it, fresh) {
    var c = fresh || (cartNow && Date.now() - cartAt < 30000 ? cartNow : null);
    if (!it || !c || !c.items) return { add: !!it };
    var nm = it.properties[NAME], ph = it.properties[PHONE] || '', harness = 0, units = 0, same = [];
    c.items.forEach(function (x) {
      if (x.variant_id === P.m.id || x.variant_id === P.l.id) {
        if (clean((x.properties || {})[NAME]).toUpperCase() === nm) { same.push(x); units += x.quantity; }
      } else if (HARN[x.handle]) harness += x.quantity;
    });
    if (!same.length || harness > units) return { add: true };
    var exact = same.some(function (x) { return x.variant_id === it.id && clean((x.properties || {})[PHONE]) === ph; });
    if (exact) return { add: false };
    return { add: true, drop: { key: same[0].key, quantity: same[0].quantity - 1 } };
  }
  function dropOld(done) {
    var d = drop; drop = null;
    if (!d) { if (done) done(); return; }
    xhr('POST', '/cart/change.js', { id: d.key, quantity: Math.max(0, d.quantity) }, function (j) {
      emit('patch_replace', { ok: !!j, mode: B.mode });
      if (j) cartNow = j;
      if (done) done(); else if (window.TK9Cart && typeof window.TK9Cart.refresh === 'function') { try { window.TK9Cart.refresh(); } catch (e) {} }
    });
  }

  // slide cart on: its hook is read at the Add press and posted right after the product's own add (earlier hooks kept).
  // One tick gives one patch line: a second press before the first add is confirmed adds no second patch.
  var prevHook = window.TK9CartExtraItems;
  window.TK9CartExtraItems = function (f) {
    var out = []; try { out = prevHook ? (prevHook(f) || []) : []; } catch (e) { out = []; }
    if (!B.on || B.used || !B.name() || !drawerOn()) return out;
    var it = patchItem(); if (!it) return out;
    var pl = plan(it);
    B.used = true; B.added = true;
    if (!pl.add) { emit('patch_skip', { via: 'drawer', mode: B.mode }); return out; }
    drop = pl.drop || null;
    emit('patch_add', { via: 'drawer', size: it.id === P.m.id ? 'm' : 'l', mode: B.mode, replace: !!drop });
    return out.concat([it]);
  };
  // the slide cart gave up on an add (it falls back to /cart): the tick may be used again
  document.addEventListener('tk9:cart', function (e) {
    var d = e.detail || {};
    if (/^tk9_cart_(error|fallback)$/.test(d.event || '')) { B.used = false; drop = null; }
    if (d.event === 'tk9_cart_add_confirmed' && drop) setTimeout(function () { dropOld(null); }, 400);
  });

  // slide cart off in this browser: Candy Rack's popup also skips buttons with class cr-ignore (its loader is off in
  // this arm anyway); our submit below adds both lines
  function crIgnore() {
    var want = B.on && !drawerOn();
    [getForm(), getSticky()].forEach(function (f) { if (!f) return; $$('[type="submit"]', f).forEach(function (b) { if (want) { b.classList.add('cr-ignore'); b.setAttribute('data-pp-cr', ''); } else if (b.hasAttribute('data-pp-cr')) { b.classList.remove('cr-ignore'); b.removeAttribute('data-pp-cr'); } }); });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error((j && (j.description || j.message)) || 'cart error'); return j; }); });
  }
  // Before any add from this page (main form or the sticky bar): a ticked patch needs its name. Window capture runs
  // before the slide cart's document listener and the theme's own handler.
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!B.on || !isOurForm(f)) return;
    if (!B.name()) {
      e.preventDefault(); e.stopImmediatePropagation();
      err.hidden = false; box.classList.add('is-missing');
      try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); nameIn.focus({ preventScroll: true }); } catch (x) {}
      emit('need_name', { from: f === getSticky() ? 'sticky' : 'form', mode: B.mode });
      return;
    }
    if (drawerOn()) return;   // the slide cart adds it through its hook
    e.preventDefault(); e.stopImmediatePropagation();
    // one add at a time: a second tap while this one is still going is ignored (it used to reach f.submit() and add a
    // second harness); this page leaves for /cart when the add is done
    if (inflight) return;
    inflight = true;
    var fd = new FormData(f), item = { id: Number(fd.get('id')), quantity: Math.max(1, Number(fd.get('quantity') || 1)), properties: {} };
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') item.properties[m[1]] = v; });
    var pi0 = B.used ? null : patchItem();
    loadCart(function (fresh) {
      var pi = pi0, pl = plan(pi, fresh);
      if (pi && !pl.add) { emit('patch_skip', { via: 'cart_page', mode: B.mode }); pi = null; }
      if (!item.id || !pi) { f.submit(); return; }
      B.used = true; drop = pl.drop || null;
      var go = function () { dropOld(function () { location.href = '/cart'; }); };
      post('/cart/add.js', { items: [item, pi] })
        .then(function () {
          emit('patch_add', { via: 'cart_page', mode: B.mode }); wpush('tk9.pp.add.' + arm); wpush('tk9.pp.patchadd.' + arm);
          xhr('POST', '/cart/update.js', { attributes: { _tk9_pp_patch_arm: low, _tk9_pp_v: PP.v } }, function () { setTimeout(go, 150); });
        })
        .catch(function (x) { B.used = false; inflight = false; drop = null; err.textContent = (x && x.message) || 'That didn’t work. Please try again.'; err.hidden = false; emit('error', { message: String(x && x.message || '').slice(0, 100) }); });
    });
  }, true);

  emit('shown', { size: pick(), mode: B.mode });
})();
